
export const defaultObjForAddOrUpdateUser = {
    active: false,
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    photo: "defaultImage",
    role:"selectUser",
    username: ""
};


export const PROFILE_PHOTO_FILE_SIZE = 2048000;

export const DEFAULT_USER_SELECTION = "selectUser";
